/* unplugin-vue-components disabled */import { render } from "./establishment.vue?vue&type=template&id=19d29bb4&scoped=true"
import script from "./establishment.vue?vue&type=script&lang=js"
export * from "./establishment.vue?vue&type=script&lang=js"

import "./establishment.vue?vue&type=style&index=0&id=19d29bb4&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d29bb4"],['__file',"src/components/cards-v2/persona/education/establishment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19d29bb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19d29bb4', __exports__)) {
    api.reload('19d29bb4', __exports__)
  }
  
  module.hot.accept("./establishment.vue?vue&type=template&id=19d29bb4&scoped=true", () => {
    api.rerender('19d29bb4', render)
  })

}


export default __exports__